import { formatPreCheckedProviders } from './formatPreCheckedProviders'

/**
 * Accepts pre-checked providers list and search params which are formatted into
 * a data object to sent to Heap to create a custom event. This function is used
 * to create events on the care detail and care search pages.
 *
 * @param {string} insuranceProduct
 * @param {array} preCheckedProviders
 * @param {string} ratingArea
 * @param {string} searchTerms
 */
export const addPreCheckedProviderEvent = ({
  insuranceProduct = '',
  preCheckedProviders = [],
  ratingArea = '',
  searchTerms = '',
}) => {
  // we should only do any of this if heap is loaded and the searchTerms and ratingArea props are passed
  if (!window.heap || !searchTerms || !ratingArea || !insuranceProduct) return

  // provider data returned from the BE
  const providerData = {
    preCheckedProvidersReturned: preCheckedProviders.length > 0,
    preCheckedProvidersCount: preCheckedProviders.length,
  }

  // format the pre-checked providers names into an object where the values is comma separated string of provider names
  const providers = formatPreCheckedProviders({ preCheckedProviders })

  // the params used to query providers
  const searchParams = {
    insuranceProduct: insuranceProduct,
    ratingArea: ratingArea,
    searchTerms: searchTerms.split(',').join(', '),
  }

  // combine providerData, providers and searchParams into one data object to send to Heap
  const preCheckedProviderData = {
    ...providerData,
    ...searchParams,
    ...providers,
  }

  // Add the custom tracking event but we need to clear the event properties
  // before we do so. We have no way of knowing what those properties are
  // and we don't seem to be setting them anywhere but without this clearing
  // the endpoints will have duplicate properties in them. Do before and
  // after just to be safe.
  window.heap.clearEventProperties()
  window.heap.track('preCheckedProviders', preCheckedProviderData)
  window.heap.clearEventProperties()
}
